import React, { useState, useEffect } from 'react';
// Importez les icônes de react-icons
import { FaFacebookSquare, FaInstagram } from 'react-icons/fa';
import './Navbar.css'; // Importer le fichier CSS

function Navbar() {
  const [isMobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!isMobileMenuOpen);
  };

  // Fonction pour fermer le menu et déclencher le défilement doux
  const closeMenuAndScroll = (event) => {
    event.preventDefault(); // Empêche le comportement de lien par défaut (saut direct)
    setMobileMenuOpen(false); // Ferme le menu mobile

    const targetId = event.currentTarget.getAttribute('href').substring(1); // Utilise currentTarget
    const targetElement = document.getElementById(targetId);

    if (targetElement) {
      window.scrollTo({
        top: targetElement.offsetTop - (isScrolled ? 70 : 70), // Ajustez la valeur (hauteur de la navbar)
        behavior: 'smooth'
      });
    }
  };

  // Effet pour gérer le changement de la navbar au scroll
  useEffect(() => {
    const handleScroll = () => {
      const scrollThreshold = 70; // Seuil en pixels avant que la navbar change

      if (window.scrollY > scrollThreshold) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <nav className={`navbar ${isScrolled ? 'scrolled' : ''} ${isMobileMenuOpen ? 'mobile-menu-active' : ''}`}>
      <div className="navbar-container">
        {/* Logo ou Nom du site */}
        <a href="#hero" className="navbar-logo" onClick={closeMenuAndScroll}>
          Fromagerie Chez Paul
        </a>

        {/* Icône Burger/Croix pour mobile */}
        <button
          className={`navbar-toggle ${isMobileMenuOpen ? 'open' : ''}`}
          onClick={toggleMobileMenu}
          aria-label={isMobileMenuOpen ? "Fermer le menu" : "Ouvrir le menu"}
          aria-expanded={isMobileMenuOpen}
        >
          <div className="burger-line line1"></div>
          <div className="burger-line line2"></div>
          <div className="burger-line line3"></div>
        </button>

        {/* Liens de navigation pour Desktop */}
        <ul className="navbar-menu desktop-menu">
          <li className="navbar-item">
            <a href="#about" className="navbar-link" onClick={closeMenuAndScroll}>Qui sommes-nous ?</a>
          </li>
          <li className="navbar-item">
            <a href="#products" className="navbar-link" onClick={closeMenuAndScroll}>Nos Fromages</a>
          </li>
          <li className="navbar-item">
            <a href="#location" className="navbar-link" onClick={closeMenuAndScroll}>Nous trouver</a>
          </li>
          <li className="navbar-item">
            <a href="#contact" className="navbar-link" onClick={closeMenuAndScroll}>Contact</a>
          </li>
          {/* NOUVEAU: Icônes réseaux sociaux pour desktop */}
          <li className="navbar-item social-icon-desktop">
            <a href="https://www.facebook.com/profile.php?id=61556009456859&mibextid=wwXIfr&rdid=iiVGoTdrEsgGHEeX&share_url=https%3A%2F%2Fwww.facebook.com%2Fshare%2F15neqbWN2B%2F%3Fmibextid%3DwwXIfr#" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
              <FaFacebookSquare />
            </a>
          </li>
          <li className="navbar-item social-icon-desktop">
            <a href="https://www.instagram.com/fromagerie_chez_paul/?hl=fr" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
              <FaInstagram />
            </a>
          </li>
        </ul>

        {/* Menu plein écran pour Mobile (Overlay) */}
        <div className={`mobile-menu ${isMobileMenuOpen ? 'open' : ''}`}>
          <ul className="mobile-menu-items">
            <li className="mobile-navbar-item">
              <a href="#hero" className="mobile-navbar-link" onClick={closeMenuAndScroll}>Accueil</a>
            </li>
            <li className="mobile-navbar-item">
              <a href="#about" className="mobile-navbar-link" onClick={closeMenuAndScroll}>Qui sommes-nous ?</a>
            </li>
            <li className="mobile-navbar-item">
              <a href="#products" className="mobile-navbar-link" onClick={closeMenuAndScroll}>Nos Fromages</a>
            </li>
            <li className="mobile-navbar-item">
              <a href="#location" className="mobile-navbar-link" onClick={closeMenuAndScroll}>Nous trouver</a>
            </li>
            <li className="mobile-navbar-item">
              <a href="#contact" className="mobile-navbar-link" onClick={closeMenuAndScroll}>Contact</a>
            </li>
            {/* NOUVEAU: Icônes réseaux sociaux pour mobile */}
            <li className="mobile-navbar-item mobile-social-links">
              <a href="https://www.facebook.com/profile.php?id=61556009456859&mibextid=wwXIfr&rdid=iiVGoTdrEsgGHEeX&share_url=https%3A%2F%2Fwww.facebook.com%2Fshare%2F15neqbWN2B%2F%3Fmibextid%3DwwXIfr#" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
                <FaFacebookSquare />
              </a>
              <a href="https://www.instagram.com/fromagerie_chez_paul/?hl=fr" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
                <FaInstagram />
              </a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;